import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import JoditEditor from "../../components/joditEditor";
import CustomButton from "../../components/customButton";
import AppLoader from "../../components/appLoader";
import { openSnackAlert } from "../../helper";
import useAdminSettings from "../../zustand/useAdminSettingsStore";

// Helper function to decode HTML entities
const decodeHtml = (html) => {
  if (!html) return "";
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

const TermsAndConditions = () => {
  const [termsContent, setTermsContent] = useState("");

  // Zustand store
  const { 
    adminSettings, 
    isLoading, 
    updateSettings: updateSettingsStore
  } = useAdminSettings();

  // Load existing data and decode HTML entities
  useEffect(() => {
    if (adminSettings?.termsAndCondtions) {
      const decodedContent = decodeHtml(adminSettings.termsAndCondtions);
      setTermsContent(decodedContent);
    }
  }, [adminSettings]);

  const handleSave = async () => {
    if (!adminSettings?._id) {
      return openSnackAlert("Settings not found. Please refresh the page.", "error");
    }

    if (!termsContent || termsContent.trim() === "" || termsContent === "<p><br></p>") {
      return openSnackAlert("Please enter terms and conditions", "error");
    }

    // Keep existing settings and only update terms
    const settingsData = {
      termsAndCondtions: termsContent,
    };

    const success = await updateSettingsStore(settingsData);
    
    if (success) {
      openSnackAlert("Terms and Conditions updated successfully!", "success");
    }
  };

  return (
    <Box>
      <AppLoader isVisible={isLoading} />
      <Typography variant="h5" mb={2}>
        Terms and Conditions
      </Typography>

      <Box mb={3}>
        <JoditEditor
          value={termsContent}
          onChange={setTermsContent}
          placeholder="Enter terms and conditions here..."
        />
      </Box>

      <Box display="flex" justifyContent="flex-end" mt={3}>
        <CustomButton
          btnLabel="Update Terms & Conditions"
          variant="webbutton"
          handlePressBtn={handleSave}
        />
      </Box>
    </Box>
  );
};

export default TermsAndConditions;

